<template>
  <div id="process-task" v-loading="loading">
    <div
      id="pkg-list-content"
      v-if="taskType === 'build' || taskType === 'watch-build'"
    >
      <el-input
        size="small"
        placeholder="请输入插件名"
        v-model="filterValue"
        class="filter-input"
        @keyup.enter.native="onSubmit"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="onSubmit"
        ></el-button>
      </el-input>
      <el-tree
        :data="pkgList"
        accordion
        :filter-node-method="filterNode"
        ref="tree"
        @node-click="nodeClick"
        :render-content="renderContent"
      />
    </div>
    <div class="drage">
      <drage
        :taskId="taskId"
        :ref="'drage' + taskId + uuid"
        :uuid="uuid"
        :taskType="taskType"
        @deleteNode="deleteNode"
      />
      <slot name="desc"></slot>
    </div>
    <config
      @quit="quit"
      :uuid="uuid"
      :routerOwnerId="routerOwnerId"
      :node="nodeNameArray"
      :taskType="taskType"
      :taskId="taskId"
      :watchData="watchData"
      @setType="setType"
      @refush="refush"
      @empty="empty"
      @close="close"
      @loading="setLoading"
      @addTab="addTab"
    />
    <processDialog
      :dialog.sync="dialog"
      @addNode="addNode"
      :selectNode="selectNode"
      :nodeName="nodeNameArray"
    />
  </div>
</template>

<script>
import drage from "./drage.vue";
import processDialog from "./processdialog.vue";
import Config from "./config.vue";
import { UUID } from "@/utils/index.js";
import * as d3 from "d3";

export default {
  name: "process-task",
  props: {
    taskType: {
      type: String,
      default: "build" // build: 编辑模式，watch: 浏览模式
    },
    taskId: {
      type: String,
      default: ""
    },
    routerOwnerId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      pkgList: [],
      filterValue: "",
      dialog: false,
      selectNode: null,
      nodeNameArray: [],
      componentId: "taskForm",
      ruleForm: {},
      groupId: null,
      watchData: null,
      uuid: "" // watch-only 模式下 使drage区分开；
    };
  },
  watch: {
    taskId: {
      immediate: true,
      handler(v) {
        if (v) {
          this.resetTask(v);
        }
      }
    },
    taskType: {
      immediate: true,
      handler(v) {
        if (v === "watch-only") {
          this.uuid = UUID(10);
        }
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    // el-tree
    getData() {
      if (this.$store.state.pkgList.lehgth) {
        this.pkgList = this.$store.state.pkgList;
      } else {
        this.$http.get("/gavial/v1/plugin/view/groups").then(res => {
          this.pkgList = this.formatList(res.data.data);
          this.$store.dispatch("setpkgList", this.pkgList);
        });
      }
    },
    formatList(data) {
      let arr = [];
      Object.keys(data).forEach(key => {
        let children = [];
        Object.keys(data[key]).forEach(key2 => {
          let children2 = data[key][key2].map(pkg => ({
            label: pkg.pkgName,
            pkg: pkg
          }));
          children.push({ label: key2, children: children2 });
        });
        arr.push({ label: key, children });
      });
      return arr;
    },
    renderContent(h, { node }) {
      if (node.data.pkg) {
        return (
          <span class="custom-tree-node" style="margin-left: -10px;">
            <i class="el-icon-ga-shengqian" style="color: var(--blue)" />
            <span>{node.label}</span>
          </span>
        );
      }
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
        </span>
      );
    },
    onSubmit() {
      this.$refs.tree.filter(this.filterValue);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    nodeClick(data) {
      if (data.pkg) {
        this.dialog = true;
        this.selectNode = data.pkg;
      }
    },
    addNode(node) {
      this.$set(this.nodeNameArray, this.nodeNameArray.length, node);
      this.$refs["drage" + this.taskId].setNode(node);
    },
    quit() {
      this.$emit("buildQuit");
    },
    empty() {
      this.nodeNameArray.forEach(node => {
        this.$refs["drage" + this.taskId].g.removeNode(node.nodeId);
      });
      this.$refs["drage" + this.taskId].renderNode();
      this.nodeNameArray = [];
    },
    watchOnlyQuit() {
      this.$emit("watchOnlyQuit");
    },
    setType(v) {
      this.$emit("setType", v);
      if (v === "watch") {
        this.empty(); // 清空node节点
        this.resetTask(this.taskId);
      }
    },
    resetTask(v) {
      this.loading = true;
      this.$http
        .get(`/gavial/v1/task/view/task/detail?id=${v}`)
        .then(res => {
          this.watchData = res.data.data;
          this.watchData.taskId = v;
          this.setNode(res.data.data.nodes);
          this.setEdge(res.data.data.nodes, res.data.data.edges);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setNode(nodes) {
      let request = nodes.map((node, index) => {
        this.$set(this.nodeNameArray, index, {
          nodeId: node.nodeId,
          jobName: node.jobName,
          pkgId: node.pkgId,
          name: node.pkgName,
          version: node.pkgVersion,
          jobParams: null,
          verOptions: node.versions || [node.pkgVersion]
        });
        return this.$http.get(
          `/gavial/v1/plugin/view/detail?name=${node.pkgName}&version=${node.pkgVersion}`
        );
      });

      Promise.all(request).then(resArr => {
        resArr.map((res, index) => {
          let params = res.data.data.params.paramSchemas;
          params.forEach(param => {
            if (nodes[index].params.hasOwnProperty(param.name)) {
              param.defaultValue = nodes[index].params[param.name];
            }
          });
          this.nodeNameArray[index].jobParams = params;
        });
        this.$emit("closeLoading");
      });
    },
    setShowNode(node) {
      this.nodeNameArray = node;
    },
    setEdge(nodes, edges) {
      nodes.forEach(node => {
        this.$refs["drage" + this.taskId + this.uuid].g.setNode(node.nodeId, {
          label: node.jobName,
          id: node.nodeId,
          class: node.status,
          paddingX: 17,
          paddingY: 7
        });
        let newNode = this.$refs["drage" + this.taskId + this.uuid].g.node(
          node.nodeId
        );
        newNode.rx = 5;
        newNode.ry = 5;
      });

      edges.forEach(edge => {
        this.$refs["drage" + this.taskId + this.uuid].g.setEdge(
          edge.source,
          edge.target,
          {
            id: `${edge.source}_${edge.target}`,
            curve: d3.curveBasis,
            arrowhead: "vee"
          }
        );
      });

      this.$refs["drage" + this.taskId + this.uuid].renderNode();
    },
    deleteNode(id) {
      let index = this.nodeNameArray.findIndex(node => node.nodeId === id);
      this.nodeNameArray.splice(index, 1);
    },
    refush() {
      this.$emit("refush");
    },
    addTab(data) {
      this.$emit("addTab", data);
    },
    close() {
      this.$emit("close");
    },
    setLoading(v) {
      this.loading = v;
    }
  },
  components: {
    drage,
    processDialog,
    Config
  }
};
</script>

<style lang="scss">
#process-task {
  height: 100%;
  width: 100%;
  top: 0;
  position: absolute;
  background: #f0f2f5;
  display: flex;
  #pkg-list-content {
    font-size: 14px;
    flex: 0 0 260px;
    overflow-x: hidden;
    overflow-y: auto;
    background: #ffffff;
    margin-right: var(--padding);
    .filter-input {
      width: calc(100% - var(--padding) * 2);
      margin: var(--padding);
    }
    .el-tree-node__content {
      height: 36px;
    }
    .el-tree-node__children {
      .el-tree-node__content,
      .el-tree-node__children .el-tree-node__content {
        padding-left: 10px !important;
      }
    }
    .custom-tree-node {
      display: flex;
      align-items: center;
      width: 100%;
      padding-right: 10px;
      overflow: hidden;
      i {
        font-size: 16px;
        margin-right: 5px;
      }
      span {
        display: block;
        flex: 1 1 auto;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .drage {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}
</style>
